import Vue from 'vue';
import { chatMessageStore } from '../../model/chat/chat-message-store.js';

export default {
	namespaced: true,
	state: {
		lastMessageByRoom: {},
		lastMsgTime: 0,
		roomMessages: {}
	},
	getters: {
		currentRoomId(state, getters, rootState, rootGetters) {
			return rootGetters['chat/currentRoomId'];
		},
		lastMessageByRoom(state) {
			return state.lastMessageByRoom;
		},
		lastMessageForRoom(state) {
			return (rid) => { return state.lastMessageByRoom[rid]; };
		},
		lastMessageTimeForRoom(state) {
			return (rid) => { 
				let msg = state.lastMessageByRoom[rid];
				if (!msg) return 0;
				return msg.ts.$date; 
			};
		},
		lastMsgTime(state) {
			return state.lastMsgTime;
		},
		roomMessages(state) {
			return state.roomMessages;
		}
	},
	mutations: {
		setAllMessages(state, lastMessageByRoom) {
			state.lastMessageByRoom = lastMessageByRoom;
		},
		// { messages, currentRoom }
		addMessages(state, payload) {
			let currentRoom = payload.currentRoom;
			let messages = payload.messages;

			for (let i = 0; i < messages.length; i++) {
				let msg = messages[i];
				state.lastMessageByRoom[msg.rid] = msg;
				if (msg.rid === currentRoom)
					Vue.set(state.roomMessages, msg._id, msg);
			}
		},
		// { message, currentRoom }
		addMessage(state, payload) {
			let message = payload.message;
			let currentRoomId = payload.currentRoom;

			state.lastMessageByRoom[msg.rid] = msg;
			if (currentRoomId == msg.rid)
				state.roomMessages[msg._id] = msg;
		},
		setLastMsgTime(state, time) {
			if (time > state.lastMsgTime)
				state.lastMsgTime = time;
		},
		clearCurrentRoomMessages(state) {
			state.roomMessages = {};
		}
	},
	actions: {
		storeMessage(state, msg)  {
            if (!msg) return;
			chatMessageStore.storeMessage(msg);
			state.commit('addMessage', 
				{ message: msg, currentRoom: state.getters.currentRoomId });
			state.commit('setLastMsgTime', msg.ts.$date);
		},
		storeMessages(state, messages)  {
			if (!messages || !messages.length)
				return;
			chatMessageStore.storeMessages(messages);
			state.commit('addMessages', 
				{ messages: messages, currentRoom: state.getters.currentRoomId });
			for (let i = 0; i < messages.length; i++)
				state.commit('setLastMsgTime', messages[i].ts.$date);
		},
		reloadRoomMessages(state, messages) {
			state.commit('clearCurrentRoomMessages');
			state.dispatch('storeMessages', messages);
		}
	}
}